export const USER_GROUPS = {
  THERAPIST: 'therapist',
  PHC_WORKER: 'phc_worker',
};

export const USER_ROLES = {
  MANAGE_EXERCISE: 'manage_exercise',
  MANAGE_EDUCATION_MATERIAL: 'manage_education_material',
  MANAGE_QUESTIONNAIRE: 'manage_questionnaire',
  MANAGE_PATIENT_REFERRAL: 'manage_patient_referral',
  MANAGE_PATIENT_REFERRAL_ASSIGNMENT: 'manage_patient_referral_assignment',
};
